import React from "react";
import s from "./App.module.scss";
import logoSrc from "../../assets/logo.svg";
import ScoresReport from "../ScoresReport";
import { constants } from "../../utils/utils";
import LoadingElement from "../LoadingElement";

export const App = () => {
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);
  const address = params.get("address");
  return (
    <div className={s.widget}>
      <div className={s.widgetBorder}>
        <header className={s.widgetHeader}>
          <a
            href={constants.REACT_APP_MAIN_URL}
            target="_blank"
            rel="noreferrer"
          >
            <img src={logoSrc} alt="Site logo" className={s.widgetHeaderLogo} />
          </a>
        </header>
        {address ? (
          <ScoresReport address={address} />
        ) : (
          <LoadingElement text={`No "address" param found in url`} />
        )}
      </div>
    </div>
  );
};

export default App;
